import React from 'react';
import { FeedRoutes } from '../features/Feed';

export const publicRoutes = [
  {
    path: '/*',
    element: <FeedRoutes />
  }
];